import React, { FC } from 'react';
import { IAccount } from '@entities/account/IAccount';
import TextForm from '@shared/form/TextForm';
import { Controller } from 'react-hook-form';
import Label from '@shared/uikit/label';

interface IProps {
  account: IAccount;
  control: any;
}

export interface IMiningAccountTypeFormValuesEdit {
  discount: number;
}

export const fillMiningAccountDefault = (account: IAccount): IMiningAccountTypeFormValuesEdit => {
  return {
    discount: account.mining_terms?.discount !== undefined ? account.mining_terms.discount : 0,
  };
};

const MiningAccountTypeEdit: FC<IProps> = ({ account, control }) => {
  return (
    <>
      <div className="grid grid-cols-[1fr_1fr] justify-items-start items-center">
        <Controller
          name="discount"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Label title="Комиссия пула" color="white" />
              <div className="w-full flex items-center gap-2 text-white">
                <div className="ml-auto w-[60px]">
                  <TextForm
                    value={field.value}
                    onChange={val => {
                      field.onChange(val);
                    }}
                    placeholder=""
                    state={fieldState}
                    type="number"
                  />
                </div>
                %
              </div>
            </>
          )}
          rules={{
            required: true,
            pattern: {
              value: /^(\d{1,2}|100)(?:[.,]\d+)?$/,
              message: 'Only numbers are allowed',
            },
          }}
        />
      </div>
    </>
  );
};

export default MiningAccountTypeEdit;
